import React from 'react';
import Confetti from 'react-confetti';
import { Box, Typography, useTheme } from '../../../base';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AllQuestionsAnswered: React.FC = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 });

    React.useEffect(() => {
        const { innerWidth, innerHeight } = window;
        setDimensions({ width: innerWidth, height: innerHeight });
    }, []);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            minHeight="calc(100vh - 160px)" // Adjust based on your header/footer height
            p={3}
        >
            <Confetti
                width={dimensions.width}
                height={dimensions.height}
                recycle={false}
                numberOfPieces={isMobile ? 500 : 2000}
                gravity={0.3}
                initialVelocityY={30}
                angle={90}
                wind={0.05}
                scalar={1.2}
                tweenDuration={5000}
            />
            <Box
                mb={2}
                sx={{
                    width: '100%',
                    height: isMobile ? '150px' : '350px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {/* Placeholder for a cool illustration */}
                <img
                    src={'/assets/imgs/congratsSuccessIllustration.png'}
                    alt="All Questions Answered"
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                    }}
                />
            </Box>
            <Typography
                variant={isMobile ? 'h5' : 'h3'}
                component="h1"
                gutterBottom
                sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}
            >
                {t('tools.companyDetails.congratulationsMessage')}
            </Typography>
            <Typography
                variant={isMobile ? 'body1' : 'h6'}
                color="textSecondary"
                paragraph
                sx={{ maxWidth: isMobile ? '90%' : '600px', mt: 2 }}
            >
                {t('tools.companyDetails.thatIsAwesome')}
            </Typography>
        </Box>
    );
};

export default AllQuestionsAnswered;
